import { render, staticRenderFns } from "./CallQueue.vue?vue&type=template&id=8a3f3e0c&scoped=true"
import script from "./CallQueue.vue?vue&type=script&lang=js"
export * from "./CallQueue.vue?vue&type=script&lang=js"
import style0 from "./CallQueue.vue?vue&type=style&index=0&id=8a3f3e0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a3f3e0c",
  null
  
)

export default component.exports